import { useLocation, useNavigate } from "react-router-dom";
import Nav from "./Nav";
import { useBillDetails } from "./api";

const Viewsales = () => {
  const navigate = useNavigate();
  const { state } = useLocation(); // state = [sid, cid, pname, price, salesdate, mode, date, balance, ndate, ..., cdate]

  // ✅ Fetch bill details from API
  const { data: bill = [], isLoading, error } = useBillDetails(state[0]);

  // Navigation handlers
  // const handleViewCustomer = () =>
  //   navigate("/viewcustomer", { state: state[1] });
  const handlePaymentUpdate = () => navigate("/paymentupdate", { state });
  // const handleEditSales = () => navigate("/editsales", { state });

  return (
    <>
      <Nav />
      <div className="container mt-5 pt-3">
        {/* Header with button */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3 className="fw-bold text-primary">🧾 Bill Details</h3>
          {/* <button className="btn btn-danger" onClick={handleViewCustomer}>
            View Customer
          </button> */}
          <button
            className="btn btn-danger"
            onClick={() => {
              navigate("/bill");
            }}
          >
            Sales
          </button>
        </div>

        {/* Sales Table */}
        <div className="card shadow border-0 mb-4">
          <div className="table-responsive">
            <table className="table table-hover align-middle mb-0">
              <thead className="table-primary">
                <tr>
                  <th>SID</th>
                  <th>Product</th>
                  <th>Price</th>
                  <th>Sales Date</th>
                  <th>Mode</th>
                  <th>Date</th>
                  <th>Balance</th>
                  <th>Next Payment</th>
                  <th>Collection Date</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={handlePaymentUpdate}
                    >
                      {state[0]}
                    </button>
                  </td>
                  <td>{state[2]}</td>
                  <td>{state[3]}</td>
                  <td>{state[4]}</td>
                  <td>{state[5]}</td>
                  <td>{state[6]}</td>
                  <td>{state[7]}</td>
                  <td>{state[8]}</td>
                  <td>{state[10]}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Bill Details Table */}
        <div className="card shadow border-0">
          <div className="table-responsive">
            {isLoading ? (
              <p className="text-center p-3">Loading bill details...</p>
            ) : error ? (
              <p className="text-center text-danger p-3">
                Failed to load bill details
              </p>
            ) : (
              <table className="table table-hover align-middle mb-0">
                <thead className="table-success">
                  <tr>
                    <th>Bill ID</th>
                    <th>Total</th>
                    <th>Balance</th>
                    <th>Paid</th>
                    <th>Paid Date</th>
                  </tr>
                </thead>
                <tbody>
                  {bill.length > 0 ? (
                    bill.map((d) => (
                      <tr key={d[0]}>
                        <td>{d[0]}</td>
                        <td>{state[3]}</td>
                        <td>{d[3]}</td>
                        <td>{d[4]}</td>
                        <td>{d[5]}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center text-muted py-3">
                        No bill records found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>
        </div>

        {/* Edit Button */}
        {/* <div className="text-end mt-3">
          <button className="btn btn-warning" onClick={handleEditSales}>
            ✏️ Edit Sales
          </button>
        </div> */}
      </div>
    </>
  );
};

export default Viewsales;
